// Mock API Helpers - Simulates network behavior

/**
 * Simulates network delay for mock API calls
 */
export const simulateNetworkDelay = (minMs: number = 200, maxMs: number = 800): Promise<void> => {
  const delay = Math.floor(Math.random() * (maxMs - minMs + 1)) + minMs;
  return new Promise((resolve) => setTimeout(resolve, delay));
};

/**
 * Simulates API response wrapper
 */
export const createMockResponse = <T>(data: T, success: boolean = true) => {
  return {
    data,
    success,
    message: success ? 'Operation successful' : 'Operation failed',
    timestamp: new Date().toISOString(),
  };
};

/**
 * Simulates random API failure (for testing error handling)
 * Set FAILURE_RATE to 0 for no failures
 */
const FAILURE_RATE = 0; // 0-1, e.g., 0.1 = 10% failure rate

export const shouldSimulateError = (): boolean => {
  return Math.random() < FAILURE_RATE;
};

/**
 * Creates a mock API error
 */
export const createMockError = (message: string, status: number = 500) => {
  const error = new Error(message) as Error & { status: number; code: string };
  error.status = status;
  error.code = `MOCK_ERROR_${status}`;
  return error;
};

/**
 * Generates a unique ID for new entities
 */
export const generateMockId = (prefix: string = 'mock'): string => {
  return `${prefix}-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;
};
